export const COST_CENTER_INFO_BASE_KEYS = [
  'budgetKeeper',
  'manager',
  'comEmail',
  'comEmailCc',
  'privilegedEmailAddress',
  'comPhone',
  'comSms'
] as const;

export const COST_CENTER_INFO_ADDRESS_KEYS = [
  'adrResStreet',
  'adrResPostalCode',
  'adrResCity',
  'brCountry',
  'requestPool'
] as const;

export const COST_CENTER_INFO_REMARKS_KEYS = [
  'issues',
  'remarks',
  'agenciesRemarks'
] as const;
